'use client';

import { HouseholdStep } from './household-step';
import { LocationStep } from './location-step';
import { ProfileStep } from './profile-step';
import { SubsidyCalculatorProvider, useSubsidyCalculator } from './provider';
import { ResultsStep } from './results-step';
import { StepIndicator } from './step-indicator';

type SubsidyCalculatorProps = {
  logo: string;
  title?: string;
  subtitle?: string;
};

function Steps() {
  const { step } = useSubsidyCalculator();

  if (step === 0) {
    return <LocationStep />;
  }

  if (step === 1) {
    return <HouseholdStep />;
  }

  if (step === 2) {
    return <ProfileStep />;
  }

  return <ResultsStep />;
}

export default function SubsidyCalculator({
  title = 'Title',
  subtitle = 'Subtitle',
  logo,
}: SubsidyCalculatorProps) {
  return (
    <div className="rounded-lg tablet:rounded-3xl shadow-lg overflow-hidden">
      <div className="bg-primary-900 text-gray-0 p-16-32">
        <img
          className="object-contain mb-12-12"
          width={200}
          height={50}
          src={logo}
          alt="Subsidy calculator logo"
        />
        <p className="hc-typography--heading-four">{title}</p>
        <p className="hc-typography--paragraph-sm">{subtitle}</p>
      </div>
      <div className="bg-gray-0 p-16-32">
        <SubsidyCalculatorProvider>
          <div className="flex mb-24-24 justify-between relative before:content-[''] before:absolute before:top-[16px] before:left-0 before:right-0 before:h-[2px] before:bg-gray-50 before:transform before:-translate-y-1/2 before:z-0">
            <StepIndicator number={1} label="Location" />
            <StepIndicator number={2} label="Household" />
            <StepIndicator number={3} label="Profile" />
            <StepIndicator number={4} label="Results" />
          </div>
          <Steps />
        </SubsidyCalculatorProvider>
      </div>
    </div>
  );
}
